import styles from './workCard.module.scss'

interface WorkCardProps {
    url: string;
    title: string;
    img?: string;
}

function WorkCard({ url, title, img }: WorkCardProps) {
    const displayUrl = url.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
    const previewSrc = img ?? `https://s.wordpress.com/mshots/v1/${encodeURIComponent(url)}?w=800&h=500`;

    const handleClick = () => {
        window.open(url, '_blank');
    };

    return (
        <div className={styles.workCard} onClick={handleClick}>
            <div className={styles.browser}>
                <div className={styles.browserBar}>
                    <div className={styles.dots}>
                        <span className={styles.dot} />
                        <span className={styles.dot} />
                        <span className={styles.dot} />
                    </div>
                    <div className={styles.urlBar}>{displayUrl}</div>
                    <div className={styles.dotsSpacer} />
                </div>
                <div className={styles.previewWrap}>
                    <img
                        src={previewSrc}
                        className={styles.img}
                        alt={title}
                        loading="lazy"
                    />
                </div>
            </div>

            <div className={styles.title}>{title}</div>
        </div>
    )
}

export default WorkCard;
